// extracted by mini-css-extract-plugin
export default {"container":"DKwwdniO_3dZaSbincp1","row":"prEbCPS3P4bWjmTMuWf3"};